import React from 'react';
import EquipmentAndMaterialTabApp from '../Functionality/EquipmentAndMaterialTabApp';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import CustomTable from '../../../../components/table/CustomTable';

const EquipmentAndMaterialTab = (props) => {
    const {
        supplierId,
        searchElement,
        setSearch,
        contractorId,
        setSimpleSearch,
        finalArray,
        search,
        setSearchElement,
        setCriteria,
        setBodyForExport,
        searchResults,
        setSearchResults,
        setItemSelected,
        itemSelected,
        setDetailsModal,
        setCheckOutModal,
        modified,
        setModified,
        t,
    } = props;
    const { option, rowsPerPage, tableId, searchId, thead, tbody, getActionsButtons, pagination } =
        EquipmentAndMaterialTabApp({
            supplierId,
            searchElement,
            setSearch,
            contractorId,
            setSimpleSearch,
            finalArray,
            search,
            setSearchElement,
            setCriteria,
            setBodyForExport,
            setItemSelected,
            searchResults,
            setSearchResults,
            setDetailsModal,
            setCheckOutModal,
            modified,
            setModified,
            t,
});
    return (
        <>
            <SearchSimple
                id={'txt_ct_search_simple'}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                textNotInformation={'no_records_available'}
            />
            {pagination()}
        </>
    );
};

export default EquipmentAndMaterialTab;
